import { AccountInfo } from '@azure/msal-browser';

/** Resolve sign-in email from MSAL account / B2C id token claims. */
export function getAccountEmail(account: AccountInfo | null | undefined): string | undefined {
	if (!account) return undefined;

	const claims = account.idTokenClaims as Record<string, unknown> | undefined;

	if (typeof claims?.email === 'string' && claims.email.trim()) {
		return claims.email.trim();
	}

	const emails = claims?.emails;
	if (Array.isArray(emails) && typeof emails[0] === 'string' && emails[0].trim()) {
		return emails[0].trim();
	}
	if (typeof emails === 'string' && emails.trim()) {
		return emails.trim();
	}

	if (typeof claims?.preferred_username === 'string' && claims.preferred_username.includes('@')) {
		return claims.preferred_username.trim();
	}

	const signInNames = claims?.signInNames as Record<string, string> | undefined;
	if (signInNames?.emailAddress?.trim()) {
		return signInNames.emailAddress.trim();
	}

	if (account.username?.includes('@')) {
		return account.username.trim();
	}

	return undefined;
}

export function getAccountNameParts(account: AccountInfo | null | undefined): {
	firstName: string;
	lastName: string;
	displayName: string;
} {
	const claims = account?.idTokenClaims as Record<string, unknown> | undefined;

	const firstName = typeof claims?.given_name === 'string' ? claims.given_name : '';
	const lastName = typeof claims?.family_name === 'string' ? claims.family_name : '';
	const displayName = typeof claims?.name === 'string' ? claims.name : '';

	return { firstName, lastName, displayName };
}
